module.exports = "<div class=\"form-control component-date-control\"> <div class=datetime-control> <input type=datetime-local class=\"ui-calendar ui-width dynamic-form-input datetime\"/> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/form/datetime-control/datetime-control.wx.html
// module id = 1975
// module chunks = 50